import { EProvince, getEProvinceList } from '@if/core/types'
import * as yup from '@if/core/yup'

const baseAddressCivicNumber = yup.text().default('')
const baseAddressStreet = yup.text().default('')
const baseAddressCity = yup.text().nullable().default('')
const baseAddressPostalCode = yup.text().nullable().default('').validCanadianPostalCode()
const baseAddressStateIso = yup
  .mixed<EProvince>()
  .nullable()
  .transform((value: string | null) => {
    return value === '' ? null : value
  })
  .default(null)
  .oneOf(getEProvinceList())
const baseAddressCountry = yup.text().nullable().default('Canada')

const fullAddressCivicNumber = baseAddressCivicNumber.required()
const fullAddressStreet = baseAddressStreet.required()
const fullAddressCity = baseAddressCity.required()
const fullAddressPostalCode = baseAddressPostalCode.required()
const fullAddressStateIso = baseAddressStateIso.required()
const fullAddressCountry = baseAddressCountry.required()

export const BaseAddressSchema = yup.object().shape({
  civicNumber: baseAddressCivicNumber,
  street: baseAddressStreet,
  apartment: yup.text().nullable(),
  suite: yup.text().nullable(),
  city: baseAddressCity,
  postalCode: baseAddressPostalCode,
  country: baseAddressCountry,
  stateIso: baseAddressStateIso,
  note: yup.text().default(''),
  years: yup.integer().min(0),
  months: yup.integer().min(0),
})

export type BaseAddress = yup.InferSubmit<typeof BaseAddressSchema>

export const AddressSchema = BaseAddressSchema.when((v, schema) => {
  const value = v[0] as BaseAddress
  if (value?.civicNumber || value?.apartment || value?.suite || value?.street || value?.city || value?.postalCode) {
    return schema.shape({
      civicNumber: fullAddressCivicNumber,
      street: fullAddressStreet,
      city: fullAddressCity,
      postalCode: fullAddressPostalCode,
      stateIso: fullAddressStateIso,
    })
  }
  return schema
})

export type Address = yup.InferSubmit<typeof AddressSchema>

export const FullAddressSchema = BaseAddressSchema.shape({
  civicNumber: fullAddressCivicNumber,
  street: fullAddressStreet,
  city: fullAddressCity,
  postalCode: fullAddressPostalCode,
  stateIso: fullAddressStateIso,
  country: fullAddressCountry,
})

export type FullAddress = yup.InferSubmit<typeof FullAddressSchema>
